export default __webpack_public_path__ + "static/media/cauliflowerbites@3x.caf37311.jpg";